//load google client file
if (window.innerWidth > 979) {
  var scriptElm = document.createElement("script");
  scriptElm.setAttribute("id", "google-one-tap-lib-js");
  scriptElm.setAttribute("type", "text/javascript");
  scriptElm.setAttribute(
    "src",
    "https://accounts.google.com/gsi/client"
  );
  scriptElm.setAttribute("defer", "defer");
  document.body.appendChild(scriptElm);
}

window.addEventListener("load", function () {
  if (typeof google !== "undefined" && !Cookie.read("bs_logging_id") && typeof showGoogleOneTapVWO !== "undefined") {
    var csrf_token,
      pageInteractEvt,
      pageSlug = window.location.pathname,
      pageSlug = pageSlug.replace(/^\/|\/$/g, ""),
      railsHost = window.location.protocol + "//" + window.location.hostname;

    if (pageSlug === "") {
      pageInteractEvt = "InteractedWithHomePage";
    } else if (pageSlug === "live") {
      pageInteractEvt = "InteractedWithLiveMarketingPage";
    }

    //Init google oneTap
    google.accounts.id.initialize({
      client_id: googleAuthClientID,
      cancel_on_tap_outside: false,
      context: "use",
      callback: function (payload) {
        //Google One Tap Email Webtracker Event
        window.hasOwnProperty("WebEventTracker")
          ? WebEventTracker.logEvent(EDS.webEvents, "GoogleOneTapCard", {
              action: "clicked email",
            })
          : "";

        window.hasOwnProperty("WebEventTracker") &&
        typeof pageInteractEvt !== "undefined"
          ? WebEventTracker.logEvent(EDS.webEvents, pageInteractEvt, {
              action: "Google One Tap Email",
            })
          : "";

        // XHR request for user token
        bsLib.ajax(
          "GET",
          railsHost + "/user/token.json",
          {},
          false,
          {},
          // Success message for user token.
          function (data) {
            var dataRequest = bsLib.JSONParse(data.response);
            if (dataRequest) {
              csrf_token = dataRequest.csrf_token;
              // XHR request for google one tap sign in
              bsLib.ajax(
                "POST",
                railsHost + "/users/google-one-tap",
                payload,
                false,
                //request header
                {
                  "X-CSRF-Token": csrf_token,
                  "content-type":
                    "application/x-www-form-urlencoded; charset=UTF-8",
                  Accept: "application/json",
                },
                //success
                function (data) {
                  var dataRequest = bsLib.JSONParse(data.response);
                  if (dataRequest.success) {
                    window.location.href = dataRequest.redirect;
                  }
                },
                //error
                function () {}
              );
            }
          },
          //error
          function () {}
        );
      },
    });
    google.accounts.id.prompt(function (notification) {
      //When prompt is displayed to user
      if (notification.isDisplayed()) {
        //Set Top position
        var promoBar = document.getElementById("promo-notification"),
          credentialPicker = document.getElementById(
            "credential_picker_container"
          ),
          headerElem = document.getElementById("header-habitat");

        if (credentialPicker && (headerElem || promoBar)) {
          credentialPicker.style.top =
            headerElem.offsetHeight +
            (promoBar ? promoBar.offsetHeight : 0) +
            "px";
        }

        //Google One Tap View Webtracker Event
        window.hasOwnProperty("WebEventTracker")
          ? WebEventTracker.logEvent(EDS.webEvents, "GoogleOneTapCard", {
              action: "view",
            })
          : "";
      }
      //When user skipped prompt
      if (notification.isSkippedMoment()) {
        //Google One Tap Cross Webtracker Event
        window.hasOwnProperty("WebEventTracker")
          ? WebEventTracker.logEvent(EDS.webEvents, "GoogleOneTapCard", {
              action: "clicked cross",
            })
          : "";

        window.hasOwnProperty("WebEventTracker") &&
        typeof pageInteractEvt !== "undefined"
          ? WebEventTracker.logEvent(EDS.webEvents, pageInteractEvt, {
              action: "Google OneTap Cross",
            })
          : "";
      }
    });
  }
});
